import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TableOfContents from './components/TableOfContents';
import WhyChooseSection from './components/WhyChooseSection';
import BonusSection from './components/BonusSection';
import GamesSection from './components/GamesSection';
import PromoBanner from './components/PromoBanner';
import TrustSection from './components/TrustSection';
import SEOBlogSection from './components/SEOBlogSection';
import ResponsibleGamblingSection from './components/ResponsibleGamblingSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import { useLanguage } from '../../contexts/LanguageContext';
import { usePageSeo } from '../../hooks/usePageSeo';

export default function HomePage() {
  const { lang, t } = useLanguage();
  const title = t(
    'MrCuci Malaysia Online Casino | Bonuses, Slots & Fast MYR Payouts',
    'Kasino Dalam Talian MrCuci Malaysia | Bonus, Slot & Bayaran MYR Pantas'
  );
  const description = t(
    'Discover MrCuci Malaysia online casino with 5,000+ slots and live games, local FPX and e-wallet payments, current bonuses and bilingual 24/7 support.',
    'Terokai kasino dalam talian MrCuci Malaysia dengan 5,000+ slot dan permainan langsung, pembayaran FPX serta e-dompet tempatan, bonus semasa dan sokongan dwibahasa 24/7.'
  );

  usePageSeo({
    title,
    description,
    path: '/',
    language: lang === 'bm' ? 'ms-MY' : 'en-MY',
    keywords: [
      'MrCuci',
      'MrCuci Malaysia',
      'MrCuci online casino',
      'Malaysia online casino',
      'online casino Malaysia',
      'trusted online casino Malaysia',
      'best online casino Malaysia',
      'casino Malaysia MYR',
      'slot online Malaysia',
      'live casino Malaysia',
      'FPX online casino Malaysia',
      'Touch n Go casino Malaysia',
      'kasino dalam talian Malaysia',
    ],
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          '@id': 'https://www.mrcuci.me/#website',
          url: 'https://www.mrcuci.me/',
          name: 'MrCuci Malaysia Online Casino',
          description,
          inLanguage: lang === 'bm' ? 'ms-MY' : 'en-MY',
        },
        {
          '@type': 'WebPage',
          '@id': 'https://www.mrcuci.me/#webpage',
          url: 'https://www.mrcuci.me/',
          name: title,
          description,
          isPartOf: { '@id': 'https://www.mrcuci.me/#website' },
          about: { '@id': 'https://www.mrcuci.me/#organization' },
          inLanguage: lang === 'bm' ? 'ms-MY' : 'en-MY',
        },
        {
          '@type': 'Organization',
          '@id': 'https://www.mrcuci.me/#organization',
          name: 'MrCuci',
          url: 'https://www.mrcuci.me/',
          logo: 'https://www.mrcuci.me/favicon.png',
          areaServed: { '@type': 'Country', name: 'Malaysia' },
        },
      ],
    },
  });

  return (
    <div className="min-h-screen bg-[#080000] font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <TableOfContents />
        <WhyChooseSection />
        <BonusSection />
        <GamesSection />
        <PromoBanner />
        <TrustSection />
        <SEOBlogSection />
        <ResponsibleGamblingSection />
        <ReviewsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
